import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { trackByValue } from '@y42/angular/util';
import { DateRangeConfig } from '../../types';

@UntilDestroy()
@Component({
  selector: 'y42-range-picker[ranges]',
  templateUrl: './range-picker.component.html',
  styleUrls: ['./range-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RangePickerComponent {
  @Input()
  ranges: DateRangeConfig[] = [];

  @Output()
  rangeSelected = new EventEmitter<DateRangeConfig>();

  protected readonly trackByValue = trackByValue;
}
